import { useMapContext } from '@components/map/MapContext';
import { useAppSelector } from '@hooks/redux.hooks';
import { hasSensorRoleFromActiveProfile, selectSessionUuid } from '@redux/authent/authent.selectors';
import { isCameraConfigurationType, isCameraStatusType } from '@utils/sensors/camera/camera.utils';

import { ActionEnum } from '@/types/commons/commons.types';
import { MapIdEnum } from '@/types/map.types';
import { SensorOrSubSensorConfiguration } from '@/types/sensor/configuration.types';
import { SensorFamilyEnum } from '@/types/sensor/sensor.types';
import { AutomatonSegmentStatus } from '@/types/sensor/sensors';
import { SensorOrSubSensorStatus } from '@/types/sensor/status.types';

export function useCameraSensorContextMenu(
  configuration: SensorOrSubSensorConfiguration | null,
  status: SensorOrSubSensorStatus | AutomatonSegmentStatus | null,
): [isHidden: boolean, isDisabled: boolean] {
  const sessionUuid = useAppSelector(selectSessionUuid);
  const { mapId } = useMapContext();

  const isCameraConfiguration = isCameraConfigurationType(configuration);
  const isCameraStatus = isCameraStatusType(status);
  const commandAction = { action: ActionEnum.COMMAND, sensorFamily: SensorFamilyEnum.CAMERA };
  const canSendCameraCommands = useAppSelector((state) => hasSensorRoleFromActiveProfile(state, commandAction));

  if (!canSendCameraCommands || !isCameraConfiguration || !isCameraStatus) {
    return [true, true];
  }

  return [mapId === MapIdEnum.REPLAY, status.cameraToken?.cameraOperatorUuid !== sessionUuid];
}
